














import { Component, Prop, Vue, Inject } from "vue-property-decorator";
import { IMenuRoute } from "@/models/routes";
import { IProductProviderData } from "@/models/providers/products";

@Component
export default class AdminCatalogueProductTemplates extends Vue {
  // Inject

  @Inject({ from: "productProviderData" })
  public readonly $productProviderData!: () => IProductProviderData;

  // Props

  @Prop({ default: () => () => [] })
  public routes!: () => IMenuRoute[];

  // Computed

  public get isStaged() {
    return this.$productProviderData()?.isStaged;
  }
}
